import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useDiscordSDK } from './hooks/useDiscordSDK';
import Gallery from './pages/Gallery';
import Generate from './pages/Generate';
import Play from './pages/Play';

function App() {
  const { isReady, isAuthenticated, user, error } = useDiscordSDK();
  const navigate = useNavigate();
  const location = useLocation();

  // Loading state
  if (!isReady) {
    return (
      <div className="app">
        <div className="loading">
          <div className="loading-spinner" />
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="app">
        <div className="loading">
          <p>Failed to connect to Discord: {error.message}</p>
        </div>
      </div>
    );
  }

  // Not authenticated
  if (!isAuthenticated) {
    return (
      <div className="app">
        <div className="loading">
          <p>Authenticating with Discord...</p>
        </div>
      </div>
    );
  }

  const currentPath = location.pathname;

  return (
    <div className="app">
      <header className="header">
        <h1>
          <span>🎮</span>
          TinyMint Arcade
        </h1>
        <nav className="nav">
          <button
            className={`nav-btn ${currentPath === '/' ? 'active' : ''}`}
            onClick={() => navigate('/')}
          >
            Gallery
          </button>
          <button
            className={`nav-btn ${currentPath === '/generate' ? 'active' : ''}`}
            onClick={() => navigate('/generate')}
          >
            Generate
          </button>
          {user && (
            <span style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
              {user.global_name || user.username}
            </span>
          )}
        </nav>
      </header>

      <main className="main">
        <Routes>
          <Route path="/" element={<Gallery />} />
          <Route path="/generate" element={<Generate />} />
          <Route path="/play/:gameId" element={<Play />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
